/* eslint-disable @trello/filename-case */
/* eslint-disable @trello/export-matches-filename */

/*
 * WARNING:
 *
 * Don't add new usages of these constants. If a constant is needed,
 * it should be provided by the @trello/enterprise package. If it's not
 * available there, it should be moved there.
 *
 * This file is being left alone for now while the dashboard gets
 * moved over to Gamma completely.
 */

export enum Tabs {
  MEMBERS = 'members',
  MANAGED_MEMBERS = 'members/managed',
  BOARDGUESTS_MEMBERS = 'members/boardguests',
  DEACTIVATED_MEMBERS = 'members/deactivated',
  TEAMS = 'teams',
  PENDING_TEAMS = 'teams/pending',
  NON_ENTERPRISE_TEAMS = 'teams/non-enterprise',
  PUBLIC_BOARDS = 'boards/public',
  TEAM_SETTINGS = 'settings',
  SSO_SETTINGS = 'sso',
  AUDIT_LOG = 'auditlog',
  POWER_UPS = 'power-ups',
  ALL_POWER_UPS = 'power-ups/all',
  IN_USE_POWER_UPS = 'power-ups/in-use',
  ALLOWED_POWER_UPS = 'power-ups/allowed',
  DISABLED_POWER_UPS = 'power-ups/disabled',
}

export const Filters = {
  ACTIVITY: 'activity',
  ADMIN: 'admin-status',
  TEAMS: 'teams',
  TRANSFERRED: 'transferred',
};

export const MembersSortItems = [
  { name: 'A-Z', sortField: 'fullName', sortOrder: 'ascending' },
  { name: 'Z-A', sortField: 'fullName', sortOrder: 'descending' },
];

export const PendingOrganizationsSortItems = [
  { name: 'A-Z', sortField: 'displayName', sortOrder: 'ascending' },
  { name: 'Z-A', sortField: 'displayName', sortOrder: 'descending' },
  {
    name: 'least-recently-created',
    sortField: 'dateCreated',
    sortOrder: 'ascending',
  },
  {
    name: 'most-recently-created',
    sortField: 'dateCreated',
    sortOrder: 'descending',
  },
];

export const PowerUpsSortItems = [
  { name: 'most-used', sortField: 'boardsCount', sortOrder: 'descending' },
  { name: 'least-used', sortField: 'boardsCount', sortOrder: 'ascending' },
  { name: 'A-Z', sortField: 'name', sortOrder: 'ascending' },
  { name: 'Z-A', sortField: 'name', sortOrder: 'descending' },
];

export const LDFlags = {
  SSO_SELF_SERVE: 'enterprise.sso_self_serve',
  NAVIGATION_REDESIGN: 'enterprise.dashboard-navigation-redesign',
  TEAM_CLAIM: 'fv.web.team-claim',
  AD_HOC_LICENSES: 'enterprise.ad-hoc-licenses',
};

export const PluginGroups = {
  ALL: { name: 'all', tabs: [Tabs.ALL_POWER_UPS, Tabs.POWER_UPS] },
  IN_USE: { name: 'in-use', tabs: [Tabs.IN_USE_POWER_UPS] },
  NOT_IN_USE: { name: 'not-in-use', tabs: [] },
  ALLOWED: { name: 'allowed', tabs: [Tabs.ALLOWED_POWER_UPS] },
  DISABLED: { name: 'disabled', tabs: [Tabs.DISABLED_POWER_UPS] },
};

// These are the loading states from the classic dashboard's ListComponent
export enum ClassicLoadingStates {
  LOADED = 0,
  LOADING_NEW = 1,
  LOADING_NEXT = 2,
  LOADING_ERROR = 3,
}

export const NON_ENTERPRISE_TEAMS_PAGE_SIZE = 20;
